import React, { useContext } from 'react'
import MemoTab from './MemoTab'
import LPHMemoTab from './LPHMemoTab'
import ExecutiveMemoTab from './ExecutiveMemoTab'
import { AuthContext } from 'context/AuthContext'

const MemoComp = () => {
  const {adminProfile} = useContext(AuthContext)

  const adminRole = adminProfile.admin_role

  if(adminRole === "lph") {
    return <LPHMemoTab/>
  }
  if(adminRole === "es") {
    return <ExecutiveMemoTab/>
  }
  return (
    <MemoTab />
  )
}

export default MemoComp